export var DisplayDataType;
(function (DisplayDataType) {
    DisplayDataType[DisplayDataType["Decimal"] = 0] = "Decimal";
    DisplayDataType[DisplayDataType["Hex"] = 1] = "Hex";
    DisplayDataType[DisplayDataType["Binary"] = 2] = "Binary";
})(DisplayDataType || (DisplayDataType = {}));
